<div class="main-header-left d-none d-lg-block">
  <div class="logo-wrapper">
    <a [routerLink]="dashboardLink">      
      <img class="blur-up lazyloaded" src="../../../../assets/images/logo1.png" width="200px" alt="">
    </a>
  </div>
</div>
<div class="sidebar custom-scrollbar" id="sidebar-menu">
  
  <div class="sidebar-user text-center">
    <div>
      <img class="img-60 rounded-circle" 
           *ngIf="!profile?.imgProfile || !isValidImageUrl(profile?.imgProfile)" 
           src="assets/images/dashboard/man.png" 
           alt="#">
      <img class="img-60 rounded-circle" 
           *ngIf="profile?.imgProfile && isValidImageUrl(profile?.imgProfile)" 
           [src]="profile.imgProfile" 
           alt="#"
           (error)="onImageError($event)">
    </div>
    <h6 class="mt-3 f-14">
      {{ getDisplayName() }}
    </h6>
    <p>
      {{ getRoleDisplayName() }}
    </p>    
  </div>
  <ul class="sidebar-menu">
    <!-- Solo visible en modo Negocio -->
    <div class="d-flex justify-content-center mb-3" *ngIf="modeService.activeMode === 'business'">
    <button class="btn btn-primary w-100" (click)="openAddCourseModal(modal)">
      <i class="fa fa-plus me-2"></i> Crear Curso
    </button>
  </div>
    <!--<a routerLink="/estudiantes" routerLinkActive="active">Estudiantes</a>-->
    <li *ngFor="let menuItem of menuItems"
        [ngClass]="{active: menuItem.active}"
        [class.sidebar-separator-li]="menuItem.type === 'separator'"
        [class.sidebar-section-li]="menuItem.type === 'section'">
      <!-- Separador simple (sin título) -->
      <hr class="sidebar-sep" *ngIf="menuItem.type === 'separator'">
      <!-- Encabezado de sección con título -->
      <div class="sidebar-section-header" *ngIf="menuItem.type === 'section'">
        {{ menuItem.title }}
      </div>
      <!-- Sub -->
      <a href="javascript:void(0)" class="sidebar-header" *ngIf="menuItem.type === 'sub'"
        (click)="toggletNavActive(menuItem)">
        <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title}}<span
            class="badge badge-{{menuItem.badgeType}} ms-3"
            *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
        <i class="fa fa-angle-right pull-right" *ngIf="menuItem.children"></i>
      </a>
      <!-- Link -->
  <a 
     class="sidebar-header" 
     *ngIf="menuItem.type === 'link'"
     [routerLink]="menuItem.path"
     routerLinkActive="active"
     [routerLinkActiveOptions]="{ exact: true }"
     style="cursor: pointer; user-select: none;">
        <app-feather-icons [icon]="menuItem.icon"></app-feather-icons>
        <span>{{menuItem.title}}
          <span class="badge badge-{{menuItem.badgeType}} ms-3"
                *ngIf="menuItem.badgeType && menuItem.badgeType !== 'launchpad'">
            {{menuItem.badgeValue}}
          </span>
          <!-- Badge especial de progreso para Launchpad -->
          <span class="lp-sidebar-badge"
                *ngIf="menuItem.badgeType === 'launchpad' && launchpadStatus && !launchpadStatus.allDone">
            {{ launchpadStatus.completedCount }}/{{ launchpadStatus.total }}
          </span>
        </span>
        <i class="fa fa-angle-right pull-right" *ngIf="menuItem.children"></i>
      </a>
      <!-- External Link -->
      <a href="{{ !menuItem.type ? null : menuItem.path }}" class="sidebar-header" *ngIf="menuItem.type === 'extLink'">
        <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title}}<span
            class="badge badge-{{menuItem.badgeType}} ms-3"
            *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
        <i class="fa fa-angle-right pull-right" *ngIf="menuItem.children"></i>
      </a>
      <!-- External Tab Link -->
      <a href="{{ !menuItem.type ? null : menuItem.path }}" target="_blank" class="sidebar-header"
        *ngIf="menuItem.type === 'extTabLink'">
        <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title}}<span
            class="badge badge-{{menuItem.badgeType}} ms-3"
            *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
        <i class="fa fa-angle-right pull-right" *ngIf="menuItem.children"></i>
      </a>
      <!-- 2nd Level Menu -->
      <ul class="sidebar-submenu" [ngClass]="{'menu-open': menuItem.active, 'menu-close': !menuItem.active }"
        *ngIf="menuItem.children">
        <li *ngFor="let childrenItem of menuItem.children" [ngClass]="{active: childrenItem.active}">
          <!-- Sub -->
          <a href="javascript:void(0)" *ngIf="childrenItem.type === 'sub'" (click)="toggletNavActive(childrenItem)">
            <i class="fa fa-circle"></i><span> {{childrenItem.title}} <span
                class="badge badge-{{childrenItem.badgeType}} pull-right"
                *ngIf="childrenItem.badgeType">{{childrenItem.badgeValue}}</span> </span>
            <i class="fa fa-angle-down pull-right" *ngIf="childrenItem.children"></i>
          </a>
          <!-- Link -->
          <a [routerLink]="!childrenItem.type ? null : childrenItem.path" *ngIf="childrenItem.type === 'link'"
            routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <i class="fa fa-circle"></i><span>{{childrenItem.title}} <span
                class="badge badge-{{childrenItem.badgeType}} pull-right"
                *ngIf="childrenItem.badgeType">{{childrenItem.badgeValue}}</span></span>
            <i class="fa fa-angle-down pull-right" *ngIf="childrenItem.children"></i>
          </a>
          <!-- External Link -->
          <a href="{{ !childrenItem.type ? null : childrenItem.path }}" *ngIf="childrenItem.type === 'extLink'"
            routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <i class="fa fa-circle"></i><span>{{childrenItem.title}} <span
                class="badge badge-{{childrenItem.badgeType}} pull-right"
                *ngIf="childrenItem.badgeType">{{childrenItem.badgeValue}}</span></span>
            <i class="fa fa-angle-down pull-right" *ngIf="childrenItem.children"></i>
          </a>
          <!-- External Tab Link -->
          <a href="{{ !childrenItem.type ? null : childrenItem.path }}" target="_blank"
            *ngIf="childrenItem.type === 'extTabLink'">
            <i class="fa fa-circle"></i><span>{{childrenItem.title}} <span
                class="badge badge-{{childrenItem.badgeType}} pull-right"
                *ngIf="childrenItem.badgeType">{{childrenItem.badgeValue}}</span></span>
            <i class="fa fa-angle-down pull-right" *ngIf="childrenItem.children"></i>
          </a>
          <!-- 3rd Level Menu -->
          <ul class="sidebar-submenu" *ngIf="childrenItem.children">
            <li *ngFor="let childrenSubItem of childrenItem.children">
              <!-- Link -->
              <a [routerLink]="!childrenSubItem.type ? null : childrenSubItem.path"
                *ngIf="childrenSubItem.type === 'link'" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-circle"></i><span> {{childrenSubItem.title}} <span
                    class="badge badge-{{childrenSubItem.badgeType}} pull-right"
                    *ngIf="childrenSubItem.badgeType">{{childrenSubItem.badgeValue}}</span> </span>
              </a>
              <!-- External Link -->
              <a href="{{ !childrenSubItem.type ? null : childrenSubItem.path }}"
                *ngIf="childrenSubItem.type === 'extLink'" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-circle"></i><span>{{childrenSubItem.title}} <span
                    class="badge badge-{{childrenSubItem.badgeType}} pull-right"
                    *ngIf="childrenSubItem.badgeType">{{childrenSubItem.badgeValue}}</span></span>
              </a>
              <!-- External Tab Link -->
              <a href="{{ !childrenSubItem.type ? null : childrenSubItem.path }}" target="_blank"
                *ngIf="childrenSubItem.type === 'extTabLink'">
                <i class="fa fa-circle"></i><span>{{childrenSubItem.title}} <span
                    class="badge badge-{{childrenSubItem.badgeType}} pull-right"
                    *ngIf="childrenSubItem.badgeType">{{childrenSubItem.badgeValue}}</span></span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>

 <ng-template #modal let-modal class="modal-dialog">
    <div class="modal-header justify-content-end">
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <h5 class="modal-title">¿Deseas asesoría para estructurar tu curso?</h5>
    <div class="modal-footer">
      <button class="btn btn-primary btn-lg" (click)="goToAddCourse(); modal.close()">
        Sí, quiero asesoría
      </button>
      <button class="btn btn-secondary btn-lg" (click)="goToAddCourseStep3(); modal.close()">
        No, continuar sin asesoría
      </button>
    </div>
</ng-template>
